<script setup lang="ts">
/**
 * Primary component for '/:workspaceId'
 *
 * Renders workspace details and a list of agents in the workspace
 */
import { useCaseStore } from '@/modules/Cases/useCaseStore'
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'

const props = defineProps<{
  workspaceId: string
}>()

const casesStore = useCaseStore()

onMounted(() => {
  // Reset store when coming from case detail, with only the
  // active case loaded, to maintain correct sort order
  if (casesStore.cases.length === 1) {
    casesStore.$reset()
    return
  } else if (casesStore.cases.length > 1) {
    return
  }

  casesStore.loadCases({ workspaceId: props.workspaceId })
})
</script>

<template>
  <div class="relative grid h-full grid-cols-[1fr_auto]">
    <RouterView />
  </div>
</template>
